import type { Styles } from '@adornis/ass/style.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import '@adornis/digitale-helden-shared/client/theme/redirect/d-redirect';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('marketing-page-admin-redirects')
export class MarketingPageAdminRedirects extends ChemistryLitElement {
  override render() {
    return html` <d-redirect></d-redirect> `;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {},
      },
    ] as Styles[];
  }
}
